// extracted by mini-css-extract-plugin
export default {"root":"style_root__7gYLt","row":"style_row__EXGPs","header":"style_header__vIwdr","cell":"style_cell__bHFpP"};